import { render, staticRenderFns } from "./audio-player.vue?vue&type=template&id=67398fd1"
import script from "./audio-player.vue?vue&type=script&lang=js"
export * from "./audio-player.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports